// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import "./common.css";

import { logCrash } from "../store/crash";

interface Props {}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: object) {
    logCrash(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="content crash">
          <h1>Oops, my bad.</h1>
          <div className="section">
            The site just crashed. Sorry about that. :-(
          </div>
          <div className="section">
            You can try refreshing your web browser. If it keeps crashing and
            you are stuck, you can email mmarucheck@gmail.com. In your email,
            please explain what you are trying to do when it crashed, and
            include the email address you used to log in to the site.
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
